module.exports = __webpack_public_path__ + "img/tx-dm0max-green120.3406b7ed.gif";